/**
 * Достаёт человекочитаемое сообщение из ошибки API.
 *
 * Бэкенд отвечает в формате RFC 7807 (ProblemDetails / ValidationProblemDetails),
 * и у такого объекта нет поля message - есть detail и title. Клиент hey-api
 * бросает разобранное тело как есть, поэтому разбираем его здесь.
 */
export const resolveApiErrorMessage = (error: unknown): string => {
  if (error !== null && typeof error === 'object') {
    const problem = error as { detail?: unknown; title?: unknown };

    if (typeof problem.detail === 'string' && problem.detail !== '')
      return problem.detail;

    if (typeof problem.title === 'string' && problem.title !== '')
      return problem.title;
  }

  if (error instanceof Error && error.message !== '') return error.message;

  return 'неизвестная ошибка';
};

/**
 * Машиночитаемый код ошибки API - поле `code` ProblemDetails (напр.
 * `sample_test_not_testing` у 409). Нет кода - undefined: тогда текст для
 * человека даёт resolveApiErrorMessage.
 */
export const resolveApiErrorCode = (error: unknown): string | undefined => {
  if (error === null || typeof error !== 'object') return undefined;

  const code = (error as { code?: unknown }).code;

  return typeof code === 'string' && code !== '' ? code : undefined;
};

/**
 * Сообщения по полям из ответа 400 (ValidationProblemDetails.errors): по одному на
 * поле, в порядке ответа. Пусто - ошибка не валидационная, показывайте
 * resolveApiErrorMessage.
 */
export const resolveApiValidationMessages = (
  error: unknown,
): ReadonlyArray<string> => {
  if (error === null || typeof error !== 'object') return [];

  const errors = (error as { errors?: unknown }).errors;
  if (errors === null || typeof errors !== 'object') return [];

  return Object.values(errors as Record<string, unknown>).flatMap((messages) =>
    Array.isArray(messages)
      ? messages.filter(
          (message): message is string => typeof message === 'string',
        )
      : [],
  );
};
